// removed by extract-text-webpack-plugin
module.exports = {"theme":"#A00203","themeBg":"#A00203","textColor":"#333","subTextColor":"#999","activeColor":"#FFFBCA"};


//////////////////
// WEBPACK FOOTER
// ./src/style/index.scss
// module id = +qiL
// module chunks = 12